<template>

        <textarea type="text"
                  rows="1"
                  ref="ref_testarea"
                  :placeholder="p_placeholder_s"
                  v-model="text_s"
                  @input="m_input_f"></textarea>

    <!--@keyup.ctrl.enter="p_keyupCtrlEnter_f"-->
    <!--@keyup.ctrl.space="p_keyupCtrlSpace_f"-->
</template>

<script>

    export default {
        name: "TqTextareaAutosize",
        props: {

            p_text_s : {
                type: String,
                default: ""
            },
            p_placeholder_s:{
                type: String,
            },
            pe_input_f:{
                type: Function,
                // require: true
            }
        },
        data(){
            return {
                text_s : this.p_text_s
            }
        },
        methods:{
            autosize(e){
                // let el = e.target
                let el = this.$refs.ref_testarea

                setTimeout(() => {

                    if(el.scrollHeight === 0 ){
                        return
                    }

                    el.style.cssText = 'height:auto; padding:0';
                    // for box-sizing other than "content-box" use:
                    // el.style.cssText = '-moz-box-sizing:content-box';
                    el.style.cssText = 'height:' + el.scrollHeight  + 'px';
                },0);
            },
            m_input_f(){
                this.pe_input_f(this.text_s)
                this.autosize()
            }
        },
        mounted(){
            this.autosize()
        }



    }
</script>

<style scoped lang="scss">


    textarea{
        width: calc(100% - 20px);
        overflow:hidden;
        /*padding:8px;*/
        /*font-size:14px;*/
        display:block;
        /*border-radius:10px;*/
        border:2px solid #556677;
        font-family: inherit;
    }



</style>